import Constants from "src/utils/constants";
import Exception from "src/utils/exception";
import DBOperationsComb from "src/utils/dbOperationsComb";

const tableName = Constants.enums.TABLES_NAME_ENUM.PRE_DEFINED_LIST_TABLE;

async function updatePreDefinedList(data) {
  try {
    return await DBOperationsComb.updateData(tableName, data);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

// Online insert. Lists are only created from the form builder, which is
// online-only, so this never takes comb's RxDB path — that path adds
// `required_sync` / `updated_at`, which pre_defined_lists doesn't have.
async function createPreDefinedList(data) {
  try {
    const res = await DBOperationsComb.insertData(tableName, data, false);
    if (res?.error) return { error: res.error, data: null };
    return { error: null, data: res?.data ?? null };
  } catch (error) {
    Exception.catchException(error);
    return { error: error?.message || String(error), data: null };
  }
}
async function getPreDefinedListById(id) {
  try {
    return await DBOperationsComb.getData(tableName, id);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getPreDefinedLists(
  config,
  customTableName = null,
  offlineFirst = true
) {
  try {
    console.log("getPreDefinedLists called ");
    return await DBOperationsComb.fetchData(
      {
        tableName: customTableName || tableName,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getPreDefinedLists,
  getPreDefinedListById,
  updatePreDefinedList,
  createPreDefinedList
};
